"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var helpers_1 = require("../../helpers");
var GridColumn_1 = require("../GridColumn");
var cellRenderers_1 = require("../cellRenderers");
exports.createProps = function (width, index, id, columnId) {
    var newProps = {
        key: columnId || "grid-" + id + "-column-" + index
    };
    if (width) {
        Object.assign(newProps, {
            width: parseInt(String(width), 10)
        });
    }
    return newProps;
};
var columnsAdapter = function (_a) {
    var columnsList = _a.columnsList, children = _a.children, selection = _a.selection, id = _a.id, toggleable = _a.toggleable;
    var gridColumns = columnsList
        ? columnsList.map(function (col) { return react_1.createElement(GridColumn_1.GridColumn, col); })
        : children;
    react_1.Children.toArray(gridColumns)
        .filter(function (col) { return react_1.default.isValidElement(col) && (col === null || col === void 0 ? void 0 : col.props.columnId); })
        .map(function (col) { return react_1.default.isValidElement(col) && (col === null || col === void 0 ? void 0 : col.props.columnId); })
        .forEach(function (id, index, self) {
        var entries = self.filter(function (selfId) { return selfId === id; }).length;
        if (entries > 1) {
            throw new Error("GridColumn ID must be unique, but \"" + id + "\" have been used " + entries + " times");
        }
    });
    var normalizedColumns = react_1.Children.toArray(gridColumns).map(function (column, index) {
        return react_1.cloneElement(column, exports.createProps(column.props.width, index, id, column.props.columnId));
    });
    if (selection === null || selection === void 0 ? void 0 : selection.checkbox) {
        normalizedColumns.unshift(react_1.createElement(GridColumn_1.GridColumn, {
            field: '',
            isSelectionColumn: true,
            key: "grid-" + id + "-selection",
            width: 36,
            cell: cellRenderers_1.checkboxCellRenderer,
            headerCell: cellRenderers_1.headerCheckboxCellRenderer
        }));
    }
    if (toggleable) {
        normalizedColumns.push(react_1.createElement(GridColumn_1.GridColumn, {
            field: '',
            isToggleColumn: true,
            key: "grid-" + id + "-toggle",
            width: helpers_1.GRID_TOGGLE_BUTTON_WIDTH
        }));
    }
    return normalizedColumns;
};
exports.default = columnsAdapter;
//# sourceMappingURL=columnsAdapter.js.map